import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { AccountSelectors } from '@recruitee/account';
import { I18nService } from '@recruitee/i18n';

import { SupportedLanguage } from '../types';

@Injectable({
  providedIn: 'root',
})
export class LanguagesService {
  public isMultilangEnabled: boolean;
  public languageSelectOptions: Array<{
    label: string;
    value: SupportedLanguage;
  }> = [];

  private supportedLanguages: SupportedLanguage[] = ['en', 'nl', 'de', 'fr', 'sv', 'fi'];

  private languageSelectOptionsKeys: Record<SupportedLanguage, string> = {
    en: 'app.common.languages.en',
    nl: 'app.common.languages.nl',
    de: 'app.common.languages.de',
    fr: 'app.common.languages.fr',
    sv: 'app.common.languages.sv',
    fi: 'app.common.languages.fi',
  };

  constructor(
    private i18n: I18nService,
    private store: Store,
  ) {
    this.languageSelectOptions = this.getLanguageSelectOptions();
    this.store
      .select(AccountSelectors.isMultilangEnabled)
      .subscribe(isMultilangEnabled => (this.isMultilangEnabled = isMultilangEnabled));
  }

  private getLanguageSelectOptions(): Array<{
    label: string;
    value: SupportedLanguage;
  }> {
    return this.supportedLanguages.map(lang => ({
      label: this.i18n.translate(this.languageSelectOptionsKeys[lang]),
      value: lang,
    }));
  }
}
